export default {
  titles: {
    error: 'Fehler',
    event: 'Veranstaltung',
    client: 'Veranstalter',
    name: 'Name',
    date: 'Datum',
  },
  errorCodes: {
    '0': 'Ein unbekannter Fehler ist aufgetreten',
    '1000': 'Sprache fehlt.',
    '1001': 'Ungültiges Datenformat.',
    '1002': 'Die Bestellung ist ungültig.',
    '1003': 'Die Bestellung ist bereits eingegangen.',
    '1004': 'Ein Produkt wurde nicht gefunden.',
    '1005': 'Ein Zutrittszeitraum wurde nicht gefunden.',
    '1006': 'Ungültige Zeiten für den Zutrittszeitraum/die Messe.',
    '1007': 'Mehrwertsteuer wurde nicht gefunden.',
    '1008': 'Fehler beim Verarbeiten der Bestellung.',
    '1009': 'Zutrittszeitraum fehlt.',
    '1010': 'Zutrittszeitraum für ein ausgewähltes Produkt fehlt.',
    '1011': 'Sie können nicht mehr als ein Ticket selber verwenden.',
    '1012': 'Es sind keine Positionen in der Bestellung.',
    '1013': 'Produkt konnte nicht hinzugefügt werden, Kontingent überschritten.',
    '1014': 'Bestellung wurde nicht gefunden.',
    '1015': 'Bestellung ist abgelaufen.',
    '1016': 'AGB oder Datenschutzbestimmungen nicht akzeptiert.',
    '1017': 'Promotionscode nicht gefunden.',
    '1018': 'Promotionscode ist abgelaufen.',
    '1019': 'Werbecode nicht verfügbar.',
    '1020': 'Kein Produkt für den Werbecode gefunden.',
    '1021': 'Werbecode ist abgelaufen.',
    '1022': 'Ticket konnte nicht eingelöst werden.',
    '1023': 'Ticket konnte nicht eingelöst werden.',
    '1024': 'Es können nicht mehrere Codes eingelöst werden.',
    '1025': 'Ticket konnte nicht eingelöst werden.',
    '1026': 'Code wurde nicht gefunden.',
    '1027': 'Der Code ist ungültig.',
    '1028': 'Code wurde nicht gefunden.',
    '1029': 'Code wurde nicht gefunden.',
    '1055': 'Das gewählte Produkt ist nicht verfügbar.',
    '1056': 'Die gewünschte Menge kann nicht Bestellt werden.',
    '1057': 'Sie können keine Eigennnutzung bei Tickets einer Ticketgruppe wählen.',
    '1058': 'Ihre Bezahldaten konnten nicht verarbeitet werden. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.',
    '1059': 'Ihre Kundendaten konnten nicht verarbeitet werden. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.',
    '1069': 'Einlösung nicht möglich. Veranstaltung liegt in der Vergangenheit.',
    '1070': 'Der Code ist leider ungültig.',
    '1079': 'Bitte entfernen Sie zuerst Ihre kostenlosen Zusatztickets aus dem Warenkorb.',
  },
  global: {
    fair: 'Landesmesse Stuttgart GmbH',
    links: {
      toLogin: 'Zum Login',
      toTicketShop: 'Zum Ticketshop',
      toShoppingCart: 'Zum Warenkorb',
      back: 'Zurück',
      lock: 'Abschließen',
      continue: 'Weiter',
      addToShoppingCart: 'In den Warenkorb',
      cancel: 'Abbrechen',
      update: 'Aktualisieren',
      change: 'Ändern',
      done: 'Fertig',
      orderWithObligationToPay: 'Zahlungspflichtig bestellen',
      requestTicket: 'Ticket anfordern',
      requestTickets: 'Tickets anfordern',
      removeArticle: 'Artikel entfernen',
      emptyShoppingCart: 'Warenkorb leeren',
    },
    formWizzard: {
      title: 'Bestellung',
      subtitle: 'Schließen Sie Ihre Bestellung ab',
    },
    forms: {
      required: '*',
      requiredInfo: 'Mit * gekennzeichnete Felder sind Pflichtfelder.',
      salutation: 'Anrede',
      title: 'Titel',
      name: 'Name',
      fullNameHint: 'Name (Vorname und Nachname)',
      firstNameHint: 'Vorname',
      lastNameHint: 'Nachname',
      fullNamePlaceholder: 'Martina Mustermann',
      firstNamePlaceHolder: 'Martina',
      lastNamePlaceHolder: 'Mustermann',
      firstName: 'Vorname',
      lastName: 'Nachname',
      company: 'Firma',
      additionalInformation: 'Zusatzinfo',
      mail: 'E-Mail',
      mailConfirm: 'E-Mail bestätigen',
      address: 'Anschrift',
      street: 'Straße',
      number: 'Nr.',
      zipCode: 'PLZ',
      city: 'Ort',
      country: 'Land',
      state: 'Bundesland',
      date: 'Datum',
      dateFrom: 'Datum von',
      dateTo: 'Datum bis',
      yes: 'Ja',
      no: 'Nein',
      pleaseSelect: 'Bitte wählen',
    },
    errorMessages: {
      unfinishedForm: 'Das Formular ist unvollständig. Bitte überprüfen Sie Ihre Angaben.',
      dataNotLoadedCorrectly: 'Einige Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    },
    paypal: {
      consentNeeded: 'Wir benötigen Ihre Zustimmung',
      paypalDisabled: 'Bitte stimmen Sie den AGB zu und bestätigen Sie die Kenntnisnahme der Datenschutzerklärung.',
      userCentricsForbidden: 'Ihre Datenschutz-Einstellungen lassen keine Bezahlung via PayPal zu. Bitte akzeptieren Sie die Datenschutz-Einstellungen für PayPal.',
      updateUserCentrics: 'Datenschutz-Einstellungen jetzt ändern',
      toPayment: 'Zur Zahlungsmittelauswahl',
      acceptPayPal: 'PayPal akzeptieren',
      showInformation: 'Mehr Informationen',
    },
  },
  shopNav: {
    tickets: 'Tickets',
    editProfile: 'Profil bearbeiten',
    guest: 'Gast',
    logIn: 'Anmelden',
    logOut: 'Abmelden',
    reserved: 'Warenkorb reserviert für: ',
    minutes: 'Minuten',
    shoppingCart: 'Warenkorb',
    cartAriaLabel: 'Warenkorb',
    emptyShoppingCart: 'Es befinden sich keine Produkte im Warenkorb',
    amount: 'Anzahl: ',
    slot: 'Zeitslot: ',
    sum: 'Gesamtsumme:',
    sumSubText: '(inkl. USt.)',
    titles: {
      toTheTickets: 'Zu den Tickets',
    },
  },
  logIn: {
    sideNav: {
      logIn: 'Anmelden',
      register: 'Registrieren',
      orderAsGuest: 'Als Gast bestellen',
    },
    loggedIn: 'Sie sind angemeldet als',
    guest: {
      bookAsGuest: 'Sie buchen als Gast',
      yourData: 'Ihre Daten:',
      removeData: 'Gast-Daten entfernen',
      newProfile: 'Jetzt Profil anlegen',
      continueAsGuest: 'Weiter',
      noGuestProduct: 'Sie haben Produkte in Ihrem Warenkorb, die eine Bestellung als Gast nicht zulassen. <br> ' +
        'Bitte melden Sie sich mit einem Messe-Login an.',
      noLoginProduct: 'Sie haben Produkte in Ihrem Warenkorb, die eine Bestellung als eingeloggter Nutzer nicht zulassen. <br> ' +
        'Bitte verwenden Sie Gast-Daten.',
      orderAsGuest: 'Ich möchte als Gast bestellen',
    },
    register: {
      headline: 'Ich möchte ein Nutzerkonto anlegen',
      infoText: {
        part1: 'Ein MyFair Nutzerkonto bei der Messe Stuttgart bietet Ihnen die Möglichkeit Ihre Angaben auch für künftige Ticketkäufe zu hinterlegen, gekaufte Tickets jederzeit online abzurufen sowie Ihre Bestellhistorie und Rechnungsdokumente einzusehen.',
        part2: 'Außerdem haben Sie ggf. Zugriff auf weitere digitale Dienste der Messe Stuttgart.',
        postRegistration: 'Nach erfolgreicher Registrierung können Sie sich direkt in Ihrem Profil anmelden und gelangen zurück auf diese Seite.',
      },
      registerNow: 'Jetzt registrieren',
    },
    alreadyRegistered: 'Ich habe bereits ein Nutzerkonto',
    shopInfo: {
      pleaseLogIn: 'Melden Sie sich mit Ihrem MyFair Nutzerkonto an, um die Bestellung bequem abzuschließen.',
      pleaseLogInBlanko: 'Melden Sie sich mit Ihrem MyFair Nutzerkonto an, um die digitalen Dienste der Messe Stuttgart nutzen zu können.',
      info: 'Über den Button "Zum Messe-Login" werden Sie auf den externen My-Bereich geleitet. Nach erfolgreichem Login gelangen Sie auf diese Seite zurück.',
    },
    addressVerificationModal: {
      headline: 'Möchten Sie Ihre Bestellung mit den folgenden Daten abschließen?',
    },
  },
  ticketList: {
    error: 'Ein Fehler ist aufgetreten. Bitte prüfen Sie die Konfiguration des Plugins.',
    selectEvent: 'Veranstaltung wählen',
    noAvailableProducts: 'Für das gewählte Event sind keine Produkte vorhanden.',
    includingVAT: 'Alle Preisangaben inklusive Ust.',
    ticketConfiguration: {
      event: 'Veranstaltung: ',
      price: '(inkl. USt.)',
      currency: '€',
      selectSlot: 'Wählen Sie den gewünschten Zeitslot für Ihren Besuch',
      info: 'Berechtigt zum einmaligen Zutritt an einem Veranstaltungsort',
      selectInfo: 'Bitte wählen Sie bei jedem Ticket einen Zeitslot aus',
      onSitePrice: 'Vor Ort:',
      soldOut: 'Ausverkauft',
      noOnSiteSale: 'Kein Verkauf vor Ort',
    },
    filter: {
      headline: 'Filtern nach:',
      reset: 'Filter zurücksetzen',
    },
    ticketCode: {
      headline: 'Sie verfügen über einen Messe-Ticket-Code?',
      subHeadline: 'Bitte hier eingeben:',
      invalidCode: 'Code {invalidCode} ist ungültig.',
      promotionCodeInShop: 'Ihr Code {invalidCode} muss im Warenkorb eingelöst werden, nachdem Sie diesem Tickets hinzugefügt haben.',
      redeemCode: 'Code einlösen',
    },
    openingTimes: {
      headline: 'Öffnungszeiten',
      time: 'Uhr',
      missing: 'Keine Angaben gefunden.',
    },
    buyTicket: {
      headline: 'Tickets kaufen',
    },
  },
  cart: {
    empty: 'Es befinden sich keine Produkte in Ihrem Warenkorb.',
    productsHint: 'Ihr Warenkorb enthält {0} Produkt(e).',
    headers: {
      ticket: 'Ticket',
      quantity: 'Anzahl',
      price: 'Summe',
      slot: 'Zeitslot',
      personalUse: 'Eigennutzung',
    },
    promotionCodes: 'Rabattcodes auf Ihren Warenkorb',
    promotionCode: 'Rabattcode',
    code: 'Code',
    totalSum: 'Gesamtsumme',
    continueShopping: 'Weiter einkaufen',
    goBack: 'Zurück',
    continue: 'Weiter',
    cartItem: {
      includingVat: 'inkl. Ust.',
      personalUse: 'Eigennutzung',
      quantity: 'Anzahl',
      event: 'Veranstaltung',
      client: 'Veranstalter',
      promotionCode: 'Rabattcode',
    },
    ticketCode: {
      headline: 'Sie verfügen über einen Messe-Ticket-Code?',
      subHeadline: 'Bitte hier eingeben:',
      invalidCode: 'Code {0} ist ungültig.',
      redeemCode: 'Code einlösen',
      usedCode: 'Sie haben den Code {0} bereits benutzt.',
      codeIsRegistrationOrAdvertising: 'Der Code {0} muss im Shop eingelöst werden.',
    },
  },
  registerTickets: {
    claimSuccess: 'Vielen Dank für Ihre Bestellung. Sie erhalten in Kürze eine E-Mail von uns mit den Tickets.',
    noRegistrationCode: 'Bitte geben Sie zunächst gültige Codes ein um diese für ein Ticket einzulösen.',
    headline: 'Personalisierung des Tickets "{0} {1}"',
    invitationHeadline: 'Sie wurden eingeladen',
    from: 'von ',
    invitationText: 'Mit der Einlösung des Eintrittscodes willigen Sie in die Weitergabe der nachfolgend angegebenen personenbezogenen Daten an den einladenden\n' +
      '            Aussteller\n' +
      '            ein.\n' +
      '            Die Weitergabe erfolgt zu dem Zweck, dass der einladende Aussteller abgleichen kann, wer von seinen eingeladenen Kontakten die Einladung angenommen\n' +
      '            hat.',
    inviterLogoAlt1: 'Logo ',
    inviterLogoAlt2: 'des Einladenden',
    code: 'Code: ',
    accountRequiredHint: 'Sie benötigen ein MyFair-Profil um dieses Produkt zu registrieren. Bitte melden Sie sich an, oder registrieren Sie sich, falls Sie noch kein Profil besitzen.',
    guestRequiredHint: 'Sie benötigen Gast-Daten um dieses Produkt zu registrieren. Bitte melden Sie sich ab und hinterlegen Sie Gast-Daten.',
    checkout: {
      selectSlot: 'Wählen Sie den gewünschten Zeitslot für Ihren Besuch',
      timeSlot: 'Zeitslots für "{0} {1}"',
      selectedSlots: 'Ausgewählte Zeitslots:',
      addressType: 'Adresstyp',
      transportation: 'Reisemöglichkeiten',
      transportationQuestion: 'Möchten Sie die kostenfreie VVS-Option nutzen?',
    },
  },
  privacy: {
    headlineClient: 'Datenschutz und Allgemeine Geschäftsbedingungen (AGB) für {eventsTitle}:',
    client: {
      privacyStatement1: 'Ich habe die ',
      privacyStatement2: 'Datenschutzbestimmungen',
      privacyStatement3: 'zur Kenntnis genommen ',
    },
    agb: {
      iAccept: 'Ich akzeptiere die ',
      agbOf: 'AGB und Widerrufsbelehrung',
    },
  },
  checkout: {
    info: {
      notLoggedIn: 'Sie sind nicht angemeldet. Bitte melden Sie sich zuerst mit einem Messe-Login oder als Gast an.',
      noOrderActiveTimer: 'Es besteht zurzeit keine Bestellung. Bitte wählen Sie vorher ein Produkt aus.',
      noOrderInactiveTimer: 'Es befinden sich aktuell keine Artikel in Ihrem Warenkorb. <br> ' +
        'Womöglich ist die Reservierungsdauer von 15 Minuten abgelaufen. Bitte gehen Sie zum Ticketshop, um mit der Auswahl fortzufahren.',
      emptyShoppingCart: 'Sie haben zurzeit keine Produkte im Warenkorb. Bitte wählen Sie vorher ein Produkt aus.',
      guestLogin: 'Sie sind zurzeit als Gast angemeldet. Bitte melden Sie sich mit Ihrem Messe-Login an.',
      guestOnly: 'Sie haben Produkte in Ihrem Warenkorb, die Sie als eingeloggter Benutzer nicht bestellen können. Bitte loggen Sie sich aus und fahren Sie als Gast fort.',
      quantityError: {
        fromTheProduct: 'Vom Produkt "{product} sind zu',
        tooMany: 'viele',
        few: 'wenige',
        ordered: 'Artikel bestellt.',
        hint: 'Bitte passen Sie die Anzahl entsprechend an.',
        minimumOrderQuantity: 'Minimale Bestellmenge: ',
        maximumOrderQuantity: 'Maximale Bestellmenge: ',
      },
    },
    personalisation: {
      title: 'Personalisierung',
      hint: 'Bitte geben Sie alle Daten für Ihr personalisiertes Ticket ein',
      addressType: 'Adresstyp',
      publicTransport: {
        headline: 'VVS-Ticket(s)',
        hintNoPublicTransport: 'Kein Ticket im Warenkorb ermöglicht die kostenfreie VVS-Option.',
        content: 'Möchten Sie Ihr Ticket um die kostenfreie VVS-Option erweitern? <br> ' +
          'Am Veranstaltungstag können Sie damit alle Nahverkehrsmittel im VVS-Netz ohne Aufpreis nutzen.',
        yes: 'Ja',
        no: 'Nein',
        firstNameHint: 'Vorname auf dem VVS-Ticket',
        lastNameHint: 'Nachname auf dem VVS-Ticket',
        select: 'VVS Tickets auswählen',
        orderHeadline: 'VVS Ticket',
        orderText: 'Bitte wählen Sie aus, an welchem Tag Sie das VVS-Ticket nutzen möchten. Die VVS - Fahrkarte ist nur am angegebenen Messetag (Fahrdatum) gültig.',
        orderTextSingle: 'Bitte wählen Sie Ihr Fahrdatum zur Nutzung der VVS - Fahrkarte. Die VVS - Fahrkarte ist nur am angegebenen Messetag (Fahrdatum) gültig.',
        orderVVSTickets: 'VVS Tickets buchen',
        orderVVSTicket: 'VVS Ticket buchen',
        noOrderVVSTicket: 'Keine VVS Tickets buchen',
        noTicketAvailable: 'Es steht kein Zeitraum zur Ticketbuchung zur Verfügung.',
        slot: 'Zeitslot',
        alreadySelected: 'Bereits ausgewählt. ',
        revert: 'Rückgängig',
        validDuringEntireEvent: 'Gültig im gesamten Zeitraum des Events.',
        orderVVSTicketsSuccess: 'Ihre VVS-Tickets wurden erfolgreich gebucht.',
        orderVVSTicketsCancellation: 'Bereits gebuchte VVS-Tickets wurden erfolgreich storniert.',
        orderVVSTicketsFailure: 'Ihre VVS-Tickets konnten nicht gebucht werden. Stellen Sie sicher, dass alle notwendigen Felder ausgefüllt sind.',
      },
      visitorSurvey: {
        headline: 'Wir haben noch ein paar Fragen',
        subHeadline: '... zu Ihrem Besuch der ',
        noQuestions: 'Keine Fragen für die Umfrage ausgewählt.',
        error: 'Fehler. Diese Frage kann nicht angezeigt werden.',
        errorInfo: 'Bitte dieses Felder ausfüllen.',
      },
      personalUse: 'Eigennutzung',
      hintNoTickets: 'Keine Tickets für die Eigennutzung ausgewählt.',
      hintNoRegistrationRequired: 'Es liegen keine personalisierbaren Tickets im Warenkorb.',
      changeUse: 'Ticketzuordnung ändern',
      personalUseModal: {
        headline: 'Möchten Sie mindestens eins der Tickets selbst nutzen?',
        info1: 'Bitte markieren Sie alle Tickets, die sie selbst nutzen möchten und tragen Sie anschließend Ihre persönlichen Daten ein, damit wir Ihr Ticket personalisieren können.',
        info2: 'Sofern Sie Tickets für andere Personen bestellen, erhalten Sie nach dem Checkout Messe-Ticketcodes zur Weitergabe an alle Ticketnutzer. So können diese die Personalisierung selbst durchführen.',
        info3: 'Sie können diesen Teil überspringen, wenn Sie ausschließlich Tickets für andere Personen bestellen.',
        info4: 'Für dieses Ticket ist keine Personalisierung erforderlich.',
        buttonNotAllSelected: 'Bitte wählen Sie Ja oder Nein für alle Tickets',
        buttonContinue: 'Weiter mit Auswahl',
        buttonSkip: 'Ich nutze kein Ticket für mich selbst.',
        buttonToCheckout: 'Weiter zum Checkout',
      },
    },
    payment: {
      title: 'Zahlungsart',
      hint: 'Bitte wählen Sie eine Zahlungsart',
      headline: 'Ihre Bezahlinformationen',
      invoiceAddressQuestion: 'Möchten Sie eine abweichende Rechnungsadresse angeben?',
      invoiceAddress: 'Ja, ich möchte eine abweichende Rechnungsadresse angeben.',
      noPaymentData: 'Keine Zahlungsdaten notwendig.',
      creditCard: {
        cardholder: 'Karteninhaber',
        cardNumber: 'Kartennummer',
        expiryDate: 'Ablaufdatum',
        cvcCvv: 'CVC/CVV',
      },
      sepa: {
        bankName: 'Name der Bank',
        bic: 'BIC',
        accountHolder: 'Kontoinhaber',
        iban: 'IBAN',
        consent: 'Ich ermächtige die Concardis GmbH, Helfman-Park 7 in 65760 Eschborn, GläubigerID DE82CC000000346626, ' +
          'Zahlungen von meinem Konto mittels SEPA-Lastschrift unter der Mandatsreferenz 4d24b95bbfa74df19dbafb1cad411411 einzuziehen. ' +
          'Zugleich weise ich mein Kreditinstitut an, die von Concardis GmbH auf mein Konto gezogenen SEPA-Lastschriften einzulösen. ' +
          'Verkürzung der Ankündigungsfrist: Die Frist für die Vorabinformation der SEPA-Lastschrift wird auf einen Tag verkürzt. ',
      },
    },
    check: {
      title: 'Überprüfen',
      noVVSSelected: 'Keine Buchung.',
      headline: 'Bitte überprüfen Sie Ihre Bestellung',
      addresses: {
        orderer: 'BestellerIn',
        invoice: 'Rechnungsadresse',
      },
      paymentMethod: 'Zahlungsart',
      noPaymentMethod: 'Keine Zahldaten erforderlich.',
    },
    finished: {
      title: 'Fertig',
      thanks: 'Vielen Dank für Ihre Bestellung. Sie erhalten in Kürze eine E-Mail mit den Daten Ihrer Bestellung.',
    },
  },
  toasts: {
    logOutSuccess: 'Sie wurden erfolgreich abgemeldet.',
    guestDataRemoved: 'Hinterlegte Gast-Daten entfernt.',
    logOutError: 'Beim Abmelden ist ein Fehler aufgetreten. Falls dieser Fehler erneut auftritt, melden Sie sich bitte in Ihrem My-Bereich ab.',
    removeProduct: 'Produkt aus Warenkorb entfernt',
    removeError: 'Fehler! Bitte versuchen Sie es erneut',
    shoppingCartUpdated: 'Warenkorb aktualisiert.',
    contingentTicket: 'Das Kontingent für dieses Ticket wurde überschritten. Das Produkt wird nicht aktualisiert.',
    contingentProduct: 'Das Kontingent für "{productTitle}" wurde überschritten. Der Warenkorb wird für dieses Ticket nicht aktualisiert.',
    contingentProducts: 'Das Kontingent für "{productTitles}" wurde überschritten. Der Warenkorb wird für diese Tickets nicht aktualisiert.',
    improperAmountOfProduct: 'Fehler {code}: Ungülige Menge von Produkt "{descriptionExternal}" im Warenkorb',
    invalidShoppingCart: 'Fehler {code}: Ungültiger Warenkorb.',
    knownMail: 'Die eingegebene E-Mail-Adresse kommt uns bekannt vor. Bitte melden Sie sich an, oder verwenden Sie eine andere E-Mail-Adresse.',
    addedToShoppingCart: 'Zum Warenkorb hinzugefügt.',
    codeOrProductNotFound: `Ihr Ticket-Code ist abgelaufen oder konnte nicht gefunden werden.`,
  },
  checkoutSuccess: {
    ticketGeneration: 'Einen Moment! Tickets werden abgerufen ({progress}%)',
    error: 'Bitte überprüfen Sie ihr Email-Postfach für Ihre Tickets.',
    noTickets: 'Ihre Bestellung beinhaltet keine herunterladbaren Tickets.',
    registrationCodes: 'Registrierungscodes zur Weitergabe für die Einlösung an Dritte',
  },
};
